import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import DataDisplay from './DataDisplay';
import { Loading } from '../../../../../components/Loading';
import { withAccount } from '../../../../../components/AccountContext';

const DATA_QUERY = gql`
query survey($accountId: ID!, $id: ID!) {
  account(id: $accountId) {
    id
    survey(id: $id) {
      id
      name
      tags
      template {
        id
        title
      }
      self {
        id
        status
      }
      managers {
        id
        status
      }
      peers {
        id
        status
      }
      directReports {
        id
        status
      }
      others {
        id
        status
      }
      commentsEnabled
    }
  }
}
`;

const DataDisplayContainer = (props) => {
  const { currentAccount, surveyId } = props;
  const variables = {
    id: surveyId,
    accountId: currentAccount,
  };

  return (
    <Query query={DATA_QUERY} variables={variables}>
      {({ data, loading, error }) => {
        if (error) {
          return `Error! ${error.message}`;
        }

        if (loading) {
          return <Loading />;
        }
        const survey = data && data.account
          ? data.account.survey
          : null;

        return (
          <DataDisplay
            survey={survey}
          />
        );
      }}
    </Query>
  );
};

DataDisplayContainer.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  surveyId: PropTypes.string.isRequired,
};

export default withAccount(DataDisplayContainer);
